










import Vue from 'vue';
import { mapGetters } from 'vuex';
import EssayReply from '@/views/EssayReply.vue';
import Correction from '@/views/Correction.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import SubjectModel from '@/models/SubjectModel';
import EssayReplyModel from '@/dex-shared/models/EssayReplyModel';

export default Vue.extend({
  components: {
    EssayReply,
    Correction,
    Loading,
  },
  computed: {
    ...mapGetters({
      essayByPosition: 'essayByPosition',
      subjectBySlug: 'subjectBySlug',
    }),
    subject(): SubjectModel {
      return this.subjectBySlug(this.$route.params.subjectSlug);
    },
    essay(): EssayReplyModel {
      return this.essayByPosition(
        this.$route.params.subjectSlug,
        +this.$route.params.position - 1,
      );
    },
  },
  created() {
    if (this.$route.params.position) {
      this.$store.dispatch('PULL_ESSAY', {
        slug: this.$route.params.subjectSlug,
        position: this.$route.params.position - 1,
      });
    } else {
      this.createDraft();
    }
  },
  methods: {
    async createDraft() {
      await this.$store.dispatch(
        'PULL_SUBJECT',
        this.$route.params.subjectSlug,
      );
      let position = await this.$store.dispatch('CREATE_DRAFT', {
        questionId: this.subject.id,
        textBody: '',
      });
      this.$router.push(`${this.subject.link()}/${position + 1}`);
      this.$router.go();
    },
  },
  beforeRouteLeave(to, from, next) {
    // needs to be in route component
    if (this.essay.status == 'DRAFT') {
      let subjectSlug = from.params.subjectSlug;
      let position = +from.params.position - 1;
      this.$store.dispatch('UPDATE_DRAFT', { subjectSlug, position });
    }
    next();
  },
});
